import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
// import { useAuth0 } from '@auth0/auth0-react';
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// ----- Imports for main window --------
import YesNoPopup from '../popup_windows/YesNoPopup';
import InfoPopup from '../popup_windows/InfoPopup';
import WorkflowEditor from '../experimental_setup/WorkflowEditor'
import FactorTableEditor from './FactorTableEditor';
import FactorTableValidation from './FactorTableValidation';
import UserSessionContext from '../user_session/context_user_session';

import { useContext, useState, useEffect } from 'react';

function DesignSpaceEditor(props) {

    // const { user } = useAuth0();
    const usr_session_ctx = useContext(UserSessionContext);

    const [showPopup, setShowPopup] = useState(false);
    const [modifications, setModifications] = useState(false);
    const [showNoModificationDetected, setShowNoModificationDetected] = useState(false)
    const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    
    // ------------------ General Window Layout -----------------------------
    const[showWorkflowEditor, setShowWorkflowEditor] = useState(false);
    const[factors, setFactors] = useState([]);
    const[title, setTitle] = useState('');
    const [triggerReload, setTriggerReload] = useState(0);
    const [triggerSave, setTriggerSave] = useState(0);
    // ------------------ Display Object Validation Information/Warnings/Errors  ---------------------------------
    const [validated, setValidated] = useState(true);
    const [validationWindow, setValidationWindow] = useState(false);
    const [validationMessage, setValidationMessage] = useState([]);
    const [showPopupEnterWorkflow, setShowPopupEnterWorkflow] = useState(false);


    useEffect( () => {
        if(typeof props.validated !== 'undefined'){ setValidated(props.validated); }
        else { setValidated(false); }
        }, []);

    useEffect( () => {
        if (props.campaign_objects.uuid_design_space !== '') {
            setIsLoading(true);
            const fetchDesignSpace = async () => {
                    setIsLoading(true);
                    const uuid_design_space = props.campaign_objects.uuid_design_space;
                try {
                    const response = await fetch(`${SERVER_URL}/current_project/load_design_space/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'uuid_tenant': usr_session_ctx.uuid_tenant
                        },
                        body: JSON.stringify(uuid_design_space),
                    });
        
                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }
        
                    const data = await response.json();
                    setFactors(data.data.factors);
                    setTitle(data.data.title);
                    setIsLoading(false);
                } catch (err) {
                    setIsLoading(false);
                    setException(true);
                    setExceptionMessage(`HTTPException: err_msg=${err.message}`);
                } 
            };
            fetchDesignSpace();
        }
    }, [triggerReload, props.campaign_objects.uuid_design_space ]);


    async function handleSave(){
        if (modifications === false && validated) {
            setShowNoModificationDetected(true);
            return;
        }
        setIsLoading(true);
        try{
            let data_design_space = { title: title, 
                                      factors: factors, 
                                      uuid_design_space: props.campaign_objects.uuid_design_space};
            let headers = {
                'Content-Type': 'application/json',
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_project/update_design_space/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data_design_space)
            });
            if(response.ok){
                const data = await response.json();
                if(data.msg === 'ok'){
                    setModifications(false);
                    setShowNoModificationDetected(false)
                    setShowUpdateSuccess(true);
                    setValidated(true);
                    if (props.handleSessionUpdate ){ 
                        props.handleSessionUpdate(props.campaign_objects)
                     }
                }
                else {
                    setValidationMessage(data.msg)
                    setValidationWindow(true)
                }
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }
    

    function onOkNoModifications(){
        setShowNoModificationDetected(false);
    }
    function onOkUpdate(){
        setShowUpdateSuccess(false);
    }

    function handleExit(event){
        if(modifications===true) {
            setShowPopup(true);
        }
        else{
            props.exit();
        }
    }

    function onYes(){
        props.exit();
    }
    function onNo(){
        setShowPopup(false);
    }


    function onYesEnterWorkflow(){
        setShowPopupEnterWorkflow(false);
        setShowWorkflowEditor(true);
        setModifications(false);
        
    }
    function onNoEnterWorkflow(){
        setShowPopupEnterWorkflow(false);
    }


    function handleTitle(event){
        setTitle(event.target.value);
        setModifications(true);
    }


    function handleUserInput(event){
        let parser = event.target.id.split('_');
        let factor_id = parser[1];
        let key = parser[0];
        if (parser.length > 2){
            factor_id = parser[2];
            key = parser[0]+'_'+parser[1];
        }
        const updatedFactors = [...factors];
        updatedFactors[factor_id] = {...updatedFactors[factor_id], [key]: event.target.value };
        setFactors(updatedFactors);
        setModifications(true);
    }

    function enterWorkflowEditor(){
        if(modifications===true) {
            setShowPopupEnterWorkflow(true);
        }
        else {
        setShowWorkflowEditor(true);
        }
    }
    
    function exitWorkflowEditor(){
        setShowWorkflowEditor(false);
        setTriggerReload(triggerReload+1);
    }

    function handleSaveValidation(){
        setValidationMessage([]);
        setValidationWindow(false);
        setTriggerSave(triggerSave+1);
    }

    useEffect(() => {
        // Make sure this is not called on first render
        if(triggerSave>0){
            handleSave();
        }
    }, [triggerSave])

    function handleExitValidation(){
        setValidationMessage([]);
        setValidationWindow(false);
    }

    function handleValidate(){
        handleSave()
    }

    // add this function as designSpaceListener to WorkflowEditor -> changes in workflow editor that require to re-validate the DesignSpace will trigger this function
    function monitorWorkflowChanges(is_change){
        setValidated(is_change);
    }


    let editor = (<></>)
    if(isLoading && !Exception){
        editor = (<div className = {'builder_canvas'} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    if(Exception){
        editor = (<>
                    <div className = {'builder_canvas'} >
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }

    if (!isLoading && !Exception && showWorkflowEditor) { 
        // Regular Content and Logic of Main Window Goes Here
        editor = (<>
                <WorkflowEditor campaign_objects={props.campaign_objects} 
                                width={props.width} 
                                height={props.height} 
                                exit={exitWorkflowEditor}
                                handleSessionUpdate={props.handleSessionUpdateOnSaveWorkflow}
                                changeDesignSpaceListener={monitorWorkflowChanges}
                                />
        </>);
    }



    if(!isLoading && !Exception && !showWorkflowEditor){

        let rquires_validation = <></>
        if(!validated){
            rquires_validation = (<>
                            <div style={{marginLeft:'20px', marginTop:'10px', marginBottom:'15px', display:'flex', justifyItems:'center'}}>
                                <button 
                                    // className={'actionButtonTiny'}
                                    className={'tableButton'}
                                    style={{marginTop:'0px', marginLeft: '0px', marginBottom:'px'}}
                                    onClick={handleValidate}
                                    >
                                    validate
                                </button>
                                <div style={{margin:'0px', padding:'0px', fontSize:'14px', color:'var(--aixelo-red)'}}>Changes in Experimental Workflow require Design Space (re)validation.</div>
                            </div>
                        </>);
        }

        if(!showPopup){
            editor = (<>
                        <div className = {'builder_canvas'} style={{height:props.height}} >
                            <h3 style={{marginTop:'10px', marginBottom:'5px' ,marginLeft:'20px', padding:'0px', color:'var(--aixelo-red)'}}>Design Space Editor</h3>
                            <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '20px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                                Factors are derived from Experimental Workflow with uuid: {props.campaign_objects.uuid_experimental_setup}.
                                <div style={{marginBottom:'3px'}}></div>
                                To add or modify factor names, please change the Experimental Workflow by clicking on 'Edit Workflow'.
                            </div>
                            <div style={{display:'flex'}}>
                                <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={handleSave}>Save</button>
                                <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={handleExit}>Exit</button>
                                <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={enterWorkflowEditor}>Edit Workflow</button>
                            </div>
                            <input id='title' style = {{marginLeft:'20px', marginTop: '10px', marginBottom: '10px', border:'none', outline:'none', padding:'5px', position: 'relative',
                                                        borderLeft: '0.5px solid var(--aixelo-gray-light)', fontSize: '24px', fontWeight:'bold', width:'94%'}} 
                                            onChange = {handleTitle} value={title} autoComplete="off" type="text" placeholder="Enter Design Space Title"  name="project_title" />
                            <div style={{width: `${props.width * 0.95 - 40}px`, marginLeft:'20px', overflow:'auto'}}>
                                <FactorTableEditor factors={factors} inputHandler={handleUserInput}/>
                            </div>   
                            {rquires_validation}                    
                        
                        </div>
                    </>
                    );
        }
        if(validationWindow) {
            let action_panel = (
                                <>
                                    <div style={{marginTop:'25px'}}>
                                        <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px'}}>Feel free to click 'Exit' to fix inconsistencies directly in Design Space Editor.</div>
                                        <div style={{display:'flex', margin:'0px'}}>
                                            <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleSaveValidation}>Save</button>
                                            <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExitValidation}>Exit</button>
                                        </div>
                                    </div>
                                </>
                                );
        
            let show_validations = (<>
                                        <div style={{position: 'relative', marginLeft:'20px', marginTop:'25px', height:'fit-content', width:`${props.width * 0.95 - 60}px`, overflow:'auto'}}>
                                            <FactorTableValidation factors={factors} invalidFactors={validationMessage.err_msg_factors} inputHandler={handleUserInput}/>
                                        </div>
                                    </>);
            editor = (<>
                        <div className = {'builder_canvas'} style={{height:props.height}} >
                            <h3 style={{marginTop:'10px', marginLeft:'20px', marginBottom:'10px', padding:'0px', color:'var(--aixelo-red)'}}>Design Space Validation</h3>
                            <div style={{marginLeft:'20px', marginBottom:'0px', fontSize:'14px'}}>The following inconsistencies in the provided design space have been detected.</div>
                            {show_validations}
                            {action_panel}
                        </div>
                    </>);
        }

        if(showPopup){
            editor = (<>
                <div className = {'builder_canvas'} >
                    <YesNoPopup ypos={'60px'} handleYes={onYes} handleNo={onNo}>
                        Modifications detected. Exit without saving?
                    </YesNoPopup>  
                </div>
            </>);
        }
        if(showPopupEnterWorkflow){
            editor = (<>
                <div className = {'builder_canvas'} >
                    <YesNoPopup ypos={'60px'} handleYes={onYesEnterWorkflow} handleNo={onNoEnterWorkflow}>
                        Unsaved modifications detected. These modifications will be lost if you proceed to the Workflow Editor. Would you like to continue?"
                    </YesNoPopup>  
                </div>
            </>);
        }
        if(showUpdateSuccess){
            editor = (<>
                <div className = {'builder_canvas'} >
                    <InfoPopup ypos={'60px'} handleOk={onOkUpdate} >
                       Successfully updated object DesignSpace!
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showNoModificationDetected){
            editor = (<>
                <div className = {'builder_canvas'} >
                    <InfoPopup ypos={'60px'} handleOk={onOkNoModifications} >
                       Object DesignSpace is already up to date.
                    </InfoPopup>  
                </div>
            </>);
        }
    }
    return (<>
                {editor}
            </>);
}

export default DesignSpaceEditor